import STable from './STable'
STable.install = function (Vue) {
  Vue.component(STable.name, STable)
}
export default STable
